import { nextTick } from 'vue';

/**
 * Adota o shell v2 e navega para o home novo.
 * O shell Cork permanece ativo enquanto a rota for Home (ver shouldUseDashboardV2Shell),
 * evitando remount do Index com Teleport quebrado.
 */
export async function switchToNewDashboardExperience(prefs, router) {
    await prefs.adoptNewDashboard();
    await nextTick();

    if (router.currentRoute.value.name !== 'dashboard') {
        await router.replace({ name: 'dashboard' });
    }
}

/**
 * Volta ao legado: primeiro troca a preferência (shell V2 some),
 * depois navega ao Início clássico.
 */
export async function switchToLegacyDashboardExperience(prefs, router) {
    await prefs.revertToLegacy();
    await nextTick();

    if (router.currentRoute.value.name === 'dashboard') {
        await router.replace({ name: 'Home' });
    }
}
